module.exports = __webpack_public_path__ + "static/media/IMG_20180806_192202.74cf8259.jpg";